module.exports = __webpack_public_path__ + "img/flow-vertical.dbfa5a8.svg";